export const orderStatus = {
    ORDER_PLACED: "Order Placed",
    QUOTE_SHARED: "Quote Shared",
    PENDING: "Pending",
    PAYMENT_PAID: "Payment paid",
    // SHIPPED: "Shipped",
    OUT_FOR_DELIVERY: "Out For Delivery",
    DELIVERED: "Delivered",
    CANCELLED: "Cancelled",
    RETURNED: "Returned"
};

export const pageStatus = {
    DRAFT: 'Draft',
    PUBLISHED: 'Published'
}

export const refundReasonOptions = [
    {
        category: "Product-Related Issues",
        reasons: [
            { value: "WRONG_ITEM_DELIVERED", label: "Wrong item delivered" },
            { value: "DAMAGED_PRODUCT", label: "Damaged product" },
            { value: "DEFECTIVE_PRODUCT", label: "Defective product" },
            { value: "MISSING_PARTS", label: "Missing parts / accessories" },
            { value: "POOR_QUALITY", label: "Poor product quality" },
            { value: "NOT_AS_DESCRIBED", label: "Product not as described" },
            { value: "EXPIRED_PRODUCT", label: "Expired or near-expiry product" },
        ]
    },
    {
        category: "Customer-Related Reasons",
        reasons: [
            { value: "CHANGED_MIND", label: "Customer changed mind" },
            { value: "ORDERED_BY_MISTAKE", label: "Customer ordered by mistake" },
            { value: "FOUND_CHEAPER", label: "Customer found cheaper elsewhere" },
            { value: "NOT_SATISFIED", label: "Customer not satisfied with product" },
            { value: "WRONG_SIZE", label: "Customer didn't like the fit/size" },
            { value: "DUPLICATE_ITEM", label: "Customer received duplicate item" },
        ]
    },
    {
        category: "Delivery-Related Issues",
        reasons: [
            { value: "LOST_IN_TRANSIT", label: "Package lost in transit" },
            { value: "ARRIVED_LATE", label: "Package arrived late" },
            { value: "DELIVERY_FAILED", label: "Delivery attempt failed" },
            { value: "RETURNED_TO_SENDER", label: "Package returned to sender" },
        ]
    },
    {
        category: "Payment / Transaction Errors",
        reasons: [
            { value: "DUPLICATE_PAYMENT", label: "Duplicate payment" },
            { value: "OVERCHARGED", label: "Overcharged amount" },
            { value: "PAYMENT_ERROR", label: "Payment processing error" },
        ]
    },
    {
        category: "Seller / Internal Reasons",
        reasons: [
            { value: "OUT_OF_STOCK", label: "Out of stock" },
            { value: "PRICING_ERROR", label: "Pricing error" },
            { value: "ORDER_CANCELLED_BY_ADMIN", label: "Order cancelled by admin" },
            { value: "FRAUD_SUSPECTED", label: "Fraudulent order suspected" },
        ]
    }
];

export const userRole = {
    ADMIN: 'Admin',
    MANAGER: 'Manager',
    SALES: 'Sales'
}

export const discountType = {
    PERCENTAGE_DISCOUNT: 'Percentage discount',
    FIXED_DISCOUNT: 'Fixed discount'
}
